/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {t} from "@util/i18n";

const expiredIcon = require("../res/images/linkExpired.png");

interface ErrorMessageProps {
    titleText: string;
    errorText: string;
}

const ErrorMessage = ({titleText, errorText}: ErrorMessageProps) => {
    return (
        <div className="bgDiv sentScreenContainer" style={{background: '#F5F5F5'}}>
            <div className="errorContainer">
                <img alt='expiredIcon' src={expiredIcon} style={{width: '144px'}}/>
                <h2 className='titleText baseText' style={{fontWeight: 700}}>{titleText}</h2>
                <p className='errorText baseText'>{errorText}</p>
                <a className='callSupport baseText' href="tel:+18558881295">{t("supportCall")}</a>
            </div>
        </div>
    );
};

export default ErrorMessage;